import DataLoader from '../data-loader';
import selectHasLoadedNeedsProducts from '../../selectors/select-has-loaded-needs-products';
import selectProductsError from '../../selectors/select-products-error';

export default DataLoader({
  selectIsDataLoaded: selectHasLoadedNeedsProducts,
  selectLoadingError: selectProductsError,
});
